import Color from '../Color.mjs'
import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    name: '引用',
    type: 'REF',
}
